<div class="create-setup" [class.create-setup--wizard-flow]="!useCombinedSetupLayout">
  <input #cloudFileInput type="file" hidden accept=".pdf,application/pdf" (change)="onPdfUpload($event)" />


  @if (useCombinedSetupLayout) {

  <div class="create-setup__top-row">
    <div class="create-setup__left">
      <div class="create-setup__card requester-card">
        <div class="requester-card__title-row">
          <img class="requester-card__icon" src="assets/requester_icon.png" alt="" />
          <span class="requester-card__title">{{ 'requesterInformation' | translate }}</span>
        </div>

        <div [formGroup]="requesterForm" class="requester-fields">
          <div class="requester-fields__subtitle">{{ 'requesterDetails' | translate }}</div>
          <div class="requester-fields__row">
            <div class="field-wrapper field-sm">
              <mat-form-field appearance="outline"
                [class.field-invalid]="requesterForm.get('name')?.invalid && (requesterForm.get('name')?.touched || requesterForm.get('name')?.dirty)">
                <input matInput [placeholder]="'name' | translate" formControlName="name" />
              </mat-form-field>
              @if(requesterForm.get('name')?.invalid && (requesterForm.get('name')?.touched ||
              requesterForm.get('name')?.dirty)) {
              <span class="field-error"><mat-icon class="field-error__icon">error_outline</mat-icon> {{ 'nameIsRequired'
                | translate }}</span>
              }
            </div>
            <div class="field-wrapper field-sm">
              <mat-form-field appearance="outline"
                [class.field-invalid]="requesterForm.get('email')?.invalid && (requesterForm.get('email')?.touched || requesterForm.get('email')?.dirty)">
                <input matInput [placeholder]="'email' | translate" formControlName="email" />
              </mat-form-field>
              @if(requesterForm.get('email')?.invalid && (requesterForm.get('email')?.touched ||
              requesterForm.get('email')?.dirty)) {
              @if(requesterForm.get('email')?.errors?.['required']) {
              <span class="field-error"><mat-icon class="field-error__icon">error_outline</mat-icon> {{
                'emailIsRequired' | translate }}</span>
              } @else {
              <span class="field-error"><mat-icon class="field-error__icon">error_outline</mat-icon> {{
                'pleaseEnterValidEmail' | translate }}</span>
              }
              }
            </div>
            <div class="phone-input-block">
              <div class="phone-input-row">
                <mat-form-field appearance="outline" class="country-select-field"
                  [class.field-invalid]="requesterForm.get('phone')?.invalid && (requesterForm.get('phone')?.touched || requesterForm.get('phone')?.dirty)">
                  <mat-select [value]="selectedCountry" (selectionChange)="onCountrySelect($event.value)"
                    (openedChange)="onCountryPanelOpened($event)" panelClass="country-select-panel"
                    [disableOptionCentering]="true">
                    <mat-select-trigger>
                      <span class="country-option">
                        <span class="country-flag">{{ selectedCountry.flag }}</span>
                        <span class="country-code">{{ selectedCountry.dialCode }}</span>
                      </span>
                    </mat-select-trigger>
                    <mat-option class="country-search-option" disabled>
                      <input matInput type="text" [placeholder]="'search' | translate"
                        [formControl]="countrySearchControl" (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()" />
                    </mat-option>
                    @for (country of filteredCountryOptions; track country.iso2) {
                    <mat-option [value]="country">
                      <span class="country-option">
                        <span class="country-flag">{{ country.flag }}</span>
                        <span class="country-name">{{ country.name }}</span>
                        <span class="country-code">{{ country.dialCode }}</span>
                      </span>
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="phone-number-field"
                  [class.field-invalid]="requesterForm.get('phone')?.invalid && (requesterForm.get('phone')?.touched || requesterForm.get('phone')?.dirty)">
                  <input matInput [placeholder]="'phone' | translate" formControlName="phone" type="tel" />
                </mat-form-field>
              </div>
              @if(requesterForm.get('phone')?.invalid && (requesterForm.get('phone')?.touched ||
              requesterForm.get('phone')?.dirty)) {
              @if(requesterForm.get('phone')?.errors?.['phoneShort']) {
              <span class="field-error phone-input-block__error"><mat-icon
                  class="field-error__icon">error_outline</mat-icon> {{ 'enterAtLeast6Digits' | translate }}</span>
              } @else if(requesterForm.get('phone')?.errors?.['phoneLong']) {
              <span class="field-error phone-input-block__error"><mat-icon
                  class="field-error__icon">error_outline</mat-icon> {{ 'phoneNumberTooLong' | translate }}</span>
              }
              }
            </div>
          </div>

          <div class="message-section">
            <label class="message-label">{{ 'newRequestEmailSubject' | translate }}</label>
            <mat-form-field appearance="outline" class="message-field subject-field">
              <input matInput [placeholder]="'subject' | translate" formControlName="emailSubject" />
            </mat-form-field>
          </div>

          <div class="message-section">
            <label class="message-label">{{ 'requesterMessageToUser' | translate }}</label>
            <mat-form-field appearance="outline" class="message-field">
              <textarea matInput [placeholder]="'message' | translate" formControlName="message" rows="3"></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="token-section">
          @if (!isDraftRequest) {
          <div class="token-section__label">
            {{ 'chooseYourAppToken' | translate }}<span class="required-asterisk">*</span>
          </div>
          <mat-form-field appearance="outline" class="app-token-field">
            <mat-select [formControl]="appToken" [placeholder]="'selectYourAppToken' | translate">
              @for(token of allTokens; track token.AppName) {
              <mat-option [value]="token">{{ token.AppName + ' (' + token.Token + ')' }}</mat-option>
              }
            </mat-select>
            <mat-error>{{ 'requiredField' | translate }}</mat-error>
          </mat-form-field>
          }
        </div>
      </div>
    </div>

    <div class="create-setup__right">
      <div class="upload-card" [class.upload-card--error]="pdfUploadError" (dragenter)="allowDrop($event)"
        (dragover)="allowDrop($event)" (drop)="handleDrop($event)">
        <div class="upload-card__inner" [class.upload-card__inner--split]="pdfPreviewUrl">
          @if (pdfPreviewUrl) {
          <div class="upload-card__preview-panel setup-doc-pdf-preview">
            <ngx-extended-pdf-viewer [src]="pdfPreviewUrl" [height]="'300px'" [showToolbar]="false"
              [showSidebarButton]="false" [sidebarVisible]="false" [showFindButton]="false"
              [showPagingButtons]="false" [showZoomButtons]="false" [showHandToolButton]="false" [zoom]="'page-width'"
              backgroundColor="#f4f6f8">
            </ngx-extended-pdf-viewer>
          </div>
          }
          <div class="upload-card__controls">
            <div class="upload-area">
              <div class="upload-area__dropzone">
                <button mat-stroked-button class="upload-area__btn" (click)="legacyFileInput.click()">
                  <mat-icon class="upload-area__btn-icon">cloud_upload</mat-icon>
                  @if(pdfFileName) { {{ 'replaceFile' | translate }} } @else { {{ 'uploadFile' | translate }} }
                </button>
                <input #legacyFileInput type="file" hidden accept=".pdf" (change)="onPdfUpload($event)" />
                <span class="upload-area__text">{{ 'clickToUploadOrDragDrop' | translate }}</span>
                <span class="upload-area__subtext">{{ 'mandatoryPdfUpload' | translate }}</span>
                @if(pdfFileName) {
                <div class="upload-area__selected">
                  <mat-icon class="upload-area__check">check_circle</mat-icon>
                  <span class="upload-area__filename">{{ resolveDocumentName() }}</span>
                </div>
                <mat-form-field appearance="outline" class="upload-card__doc-name">
                  <mat-label>{{ 'docName' | translate }}</mat-label>
                  <input matInput [formControl]="docNameControl" />
                  @if (docNameControl.invalid && docNameControl.touched) {
                  <mat-error>{{ 'requiredField' | translate }}</mat-error>
                  }
                </mat-form-field>
                }
                @if(pdfUploadError) {
                <span class="field-error upload-area__pdf-error"><mat-icon
                    class="field-error__icon">error_outline</mat-icon> {{ 'pdfFileRequired' | translate }}</span>
                }
              </div>
            </div>

            <div class="upload-card__or">
              <span>{{ 'or' | translate }}</span>
            </div>

            <div class="cloud-section">
              <span class="cloud-section__label">{{ 'chooseFileFromCloud' | translate }}</span>
              <div class="cloud-section__icons">
                <img src="assets/drive-icon.png" alt="Google Drive" class="cloud-icon-img"
                  title="Pick from Google Drive" />
                <img src="assets/Dropbox_Icon.png" alt="Dropbox" class="cloud-icon-img" title="Pick from Dropbox" />
                <img src="assets/one_drive.png" alt="OneDrive" class="cloud-icon-img" title="Pick from OneDrive" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (!hideManageUsersSection) {
  <div class="create-setup__card users-card">
    <div class="users-card__header">
      <span class="users-card__title"><img src="assets/manage_user_icon.png" alt="" class="users-card__title-icon" /> {{
        'manageUsers' | translate }}</span>
      <div class="users-card__header-right">
        <div class="users-card__header-actions">
          <label class="signing-order-switch">
            <mat-slide-toggle [(ngModel)]="signingOrderEnabled"
              [ngModelOptions]="{ standalone: true }"></mat-slide-toggle>
            <span class="signing-order-switch__label">{{ 'signingOrder' | translate }}</span>
          </label>
          <button type="button" mat-stroked-button class="add-me-btn" (click)="addMe()">{{ 'addMe' | translate
            }}</button>
          <button type="button" mat-raised-button color="primary" class="add-user-btn" (click)="addNewUser()">
            <mat-icon>add</mat-icon> {{ 'addUser' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="users-card__table-scroll">
      <kzn-table [showSearch]="false" [showPagination]="false" [showOrderColumn]="true"
        [enableRowReorder]="signingOrderEnabled" [data]="tableService.tableInputData" [columns]="tableColumns"
        [rowActions]="tableRowActions" actionColumnHeader="action" style="width:100%">
      </kzn-table>
    </div>
  </div>
  }

  <div class="create-setup__actions">
    <button mat-button class="action-skip" type="button" (click)="onNext.emit()">{{ 'skipTag' | translate }}</button>
    <button mat-button class="action-reset" type="button" (click)="onReset.emit()">{{ 'reset' | translate }}</button>
    <button mat-raised-button class="action-next" color="primary" type="button" (click)="handleNextClick()">{{ 'next' |
      translate }}</button>
  </div>

  }

  @if (!useCombinedSetupLayout && wizardSetupPhase === 0) {
  <div class="csr-doc">
    <div class="csr-doc__shell">
      <header class="csr-doc__header">
        <div class="csr-doc__header-main">
          @if (!requestId) {
          <span class="csr-doc__greeting">
            {{ greetingKey | translate: { name: greetingName || '-' } }}
          </span>
          <p class="csr-doc__subtitle">
            {{ 'dashboardHomeSubtitle' | translate }}
          </p>
          } @else {
          <p class="csr-doc__greeting">
            Edit Request {{requestId}}.
          </p>
          }

        </div>
      </header>

      <div class="csr-doc__main-row">
        <section class="csr-doc__dropzone" [class.csr-doc__dropzone--error]="pdfUploadError"
          [class.csr-doc__dropzone--has-preview]="pdfPreviewUrl" (dragenter)="allowDrop($event)"
          (dragover)="allowDrop($event)" (drop)="handleDrop($event)">
          @if (pdfPreviewUrl) {
          <div class="csr-doc__preview-panel setup-doc-pdf-preview">
            <ngx-extended-pdf-viewer [src]="pdfPreviewUrl" [height]="'380px'" [showToolbar]="false"
              [showSidebarButton]="false" [sidebarVisible]="false" [showFindButton]="false"
              [showPagingButtons]="false" [showZoomButtons]="false" [showHandToolButton]="false" [zoom]="'page-width'"
              backgroundColor="#f4f6f8">
            </ngx-extended-pdf-viewer>
          </div>
          }

          <div class="csr-doc__dropzone-inner" [class.csr-doc__dropzone-inner--with-preview]="pdfPreviewUrl">
            <div class="csr-doc__controls-panel">
              <div class="csr-doc__upload-row">
                <button mat-flat-button type="button" class="csr-doc__upload-btn" (click)="fileInputW.click()">
                  <mat-icon>arrow_circle_up</mat-icon>
                  <span>{{ pdfFileName ? ('replaceFile' | translate) : ('dashboardUploadPdf' | translate) }}</span>
                </button>
              </div>
              <input #fileInputW type="file" hidden accept=".pdf" (change)="onPdfUpload($event)" />

              <p class="csr-doc__hint csr-doc__hint--bold">{{ 'clickToUploadOrDragDrop' | translate }}</p>
              <p class="csr-doc__hint">{{ 'mandatoryPdfUpload' | translate }}</p>

              <div class="csr-doc__or"><span>{{ 'or' | translate }}</span></div>

              <p class="csr-doc__cloud-label">{{ 'chooseFileFromCloud' | translate }}</p>
              <div class="csr-doc__cloud-icons">
                <img src="assets/drive-icon.png" alt="Google Drive" />
                <img src="assets/Dropbox_Icon.png" alt="Dropbox" />
                <img src="assets/one_drive.png" alt="OneDrive" />
              </div>

              @if (pdfFileName) {
              <div class="csr-doc__file-card">
                <div class="csr-doc__file-icon">
                  <mat-icon>picture_as_pdf</mat-icon>
                </div>
                <mat-form-field appearance="outline" class="csr-doc__doc-name-field">
                  <mat-label>{{ 'docName' | translate }}</mat-label>
                  <input matInput [formControl]="docNameControl" />
                  @if (docNameControl.invalid && docNameControl.touched) {
                  <mat-error>{{ 'requiredField' | translate }}</mat-error>
                  }
                </mat-form-field>
                <div class="csr-doc__file-sub">
                  @if (pdfFileSize) { <span>{{ pdfFileSize }}</span> }
                  @if (pdfFileSize && pdfFileDate) { <span class="csr-doc__file-dot">•</span> }
                  @if (pdfFileDate) { <span>{{ pdfFileDate }}</span> }
                </div>
              </div>
              }

              @if (isSelfSignRequestPath) {
              <div class="csr-doc__token-section">
                <label class="csr-doc__token-label">
                  {{ 'chooseYourAppToken' | translate }}<span class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="outline" class="csr-doc__token-field"
                  [class.field-invalid]="appToken.invalid && appToken.touched">
                  <mat-select [formControl]="appToken" [placeholder]="'selectYourAppToken' | translate">
                    @for (token of allTokens; track token.AppName) {
                    <mat-option [value]="token">{{ token.AppName + ' (' + token.Token + ')' }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (appToken.invalid && appToken.touched) {
                <span class="field-error csr-doc__token-error">
                  <mat-icon class="field-error__icon">error_outline</mat-icon>
                  {{ 'requiredField' | translate }}
                </span>
                }
              </div>
              }

              @if (pdfUploadError) {
              <span class="field-error csr-doc__error">
                <mat-icon class="field-error__icon">error_outline</mat-icon>
                {{ 'pdfFileRequired' | translate }}
              </span>
              }
            </div>
          </div>
        </section>
      </div>


      @if (pdfFileName) {
      <div class="csr-doc__footer">
        <button mat-flat-button type="button" class="wiz-btn-orange1 csr-doc__footer-send" (click)="handleNextClick()">
          {{ uploadNextLabelKey | translate }}
        </button>
      </div>}
    </div>

  </div>
  }


  @if (!useCombinedSetupLayout && wizardSetupPhase === 1) {
  <div class="wiz-signer-layout">
    <span class="wiz-section-title">{{ 'manageSignersTitle' | translate }}</span>

    <div class="signer-card">

      <div class="signer-panel" [class.signer-panel--active]="signerPanel === 'requester'"
        [class.signer-panel--has-error]="requesterPanelHasErrors() && signerPanel !== 'requester'">
        <button type="button" class="signer-panel__head" (click)="signerPanel = 'requester'">
          <span class="signer-panel__radio" [class.is-on]="signerPanel === 'requester'"></span>
          <span class="signer-panel__title">{{ 'requesterInformation' | translate }}</span>
          @if (requesterPanelHasErrors() && signerPanel !== 'requester') {
          <mat-icon class="signer-panel__error-icon" aria-hidden="true">error_outline</mat-icon>
          }
        </button>

        @if (signerPanel === 'requester') {
        <div class="signer-panel__body signer-panel__body--requester" [formGroup]="requesterForm">
          <div class="signer-panel__fields-box">
            <div class="signer-panel__row signer-panel__row--requester">

              <div class="signer-panel__field-wrap">
                <mat-form-field appearance="outline" class="signer-panel__field signer-panel__field--white"
                  [class.field-invalid]="requesterForm.get('name')?.invalid && requesterForm.get('name')?.touched">
                  <input matInput [placeholder]="'name' | translate" formControlName="name" />
                </mat-form-field>
                @if (requesterForm.get('name')?.invalid && requesterForm.get('name')?.touched) {
                <span class="field-error signer-panel__field-error">
                  <mat-icon class="field-error__icon">error_outline</mat-icon> {{ 'nameIsRequired' | translate }}
                </span>
                }
              </div>
              <div class="signer-panel__field-wrap">
                <mat-form-field appearance="outline" class="signer-panel__field signer-panel__field--white"
                  [class.field-invalid]="requesterForm.get('email')?.invalid && requesterForm.get('email')?.touched">
                  <input matInput [placeholder]="'email' | translate" formControlName="email" />
                </mat-form-field>
                @if (requesterForm.get('email')?.invalid && requesterForm.get('email')?.touched) {
                @if (requesterForm.get('email')?.errors?.['required']) {
                <span class="field-error signer-panel__field-error">
                  <mat-icon class="field-error__icon">error_outline</mat-icon> {{ 'emailIsRequired' | translate }}
                </span>
                } @else {
                <span class="field-error signer-panel__field-error">
                  <mat-icon class="field-error__icon">error_outline</mat-icon> {{ 'pleaseEnterValidEmail' | translate }}
                </span>
                }
                }
              </div>
              <div class="signer-panel__field-wrap signer-panel__field-wrap--phone">
                <div class="signer-panel__phone signer-panel__field--white">
                  <mat-form-field appearance="outline" class="country-select-field"
                    [class.field-invalid]="requesterForm.get('phone')?.invalid && requesterForm.get('phone')?.touched">
                    <mat-select [value]="selectedCountry" (selectionChange)="onCountrySelect($event.value)"
                      (openedChange)="onCountryPanelOpened($event)" panelClass="country-select-panel"
                      [disableOptionCentering]="true">
                      <mat-select-trigger>
                        <span class="country-option">
                          <span class="country-flag">{{ selectedCountry.flag }}</span>
                          <span class="country-code">{{ selectedCountry.dialCode }}</span>
                        </span>
                      </mat-select-trigger>
                      <mat-option class="country-search-option" disabled>
                        <input matInput type="text" [placeholder]="'search' | translate"
                          [formControl]="countrySearchControl" (click)="$event.stopPropagation()"
                          (keydown)="$event.stopPropagation()" />
                      </mat-option>

                      @for (country of filteredCountryOptions; track country.iso2) {
                      <mat-option [value]="country">
                        <span class="country-option">
                          <span class="country-flag">{{ country.flag }}</span>
                          <span class="country-name">{{ country.name }}</span>
                          <span class="country-code">{{ country.dialCode }}</span>
                        </span>
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="phone-number-field"
                    [class.field-invalid]="requesterForm.get('phone')?.invalid && requesterForm.get('phone')?.touched">
                    <input matInput placeholder="1234567890" formControlName="phone" type="tel" />
                  </mat-form-field>
                </div>
                @if (requesterForm.get('phone')?.invalid && requesterForm.get('phone')?.touched) {
                @if (requesterForm.get('phone')?.errors?.['phoneShort']) {
                <span class="field-error signer-panel__field-error">
                  <mat-icon class="field-error__icon">error_outline</mat-icon> {{ 'enterAtLeast6Digits' | translate }}
                </span>
                } @else if (requesterForm.get('phone')?.errors?.['phoneLong']) {
                <span class="field-error signer-panel__field-error">
                  <mat-icon class="field-error__icon">error_outline</mat-icon> {{ 'phoneNumberTooLong' | translate }}
                </span>
                }
                }
              </div>
            </div>
          </div>
        </div>
        }
      </div>


      @if (!hideManageUsersSection) {
      <div class="signer-panel" [class.signer-panel--active]="signerPanel === 'users'"
        [class.signer-panel--has-error]="manageUsersPanelHasErrors() && signerPanel !== 'users'">
        <button type="button" class="signer-panel__head" (click)="signerPanel = 'users'">
          <span class="signer-panel__radio" [class.is-on]="signerPanel === 'users'"></span>
          <span class="signer-panel__title">{{ 'manageUsers' | translate }}</span>
          @if (manageUsersPanelHasErrors() && signerPanel !== 'users') {
          <mat-icon class="signer-panel__error-icon" aria-hidden="true">error_outline</mat-icon>
          }
        </button>

        @if (signerPanel === 'users') {
        <div class="signer-panel__body signer-panel__body--users">
          <div class="signer-panel__users-box">
            <div class="signer-panel__users-top">
              <div class="signer-panel__users-top-action">
                <label class="signing-order-switch">
                  <mat-slide-toggle [(ngModel)]="signingOrderEnabled"
                    [ngModelOptions]="{ standalone: true }"></mat-slide-toggle>
                  <span class="signing-order-switch__label">{{ 'signingOrder' | translate }}</span>
                </label>
                <button type="button" mat-stroked-button class="signer-panel__add-me-btn" (click)="addMe()">
                  {{ 'addMe' | translate }}
                </button>
                <button type="button" mat-flat-button class="signer-panel__add-user-btn" (click)="addNewUser()">
                  <mat-icon>add</mat-icon> {{ 'addUser' | translate }}
                </button>
              </div>
            </div>
            <div class="signer-panel__users-table-wrap">
              <kzn-table [showSearch]="false" [showPagination]="false" [showOrderColumn]="true"
                [enableRowReorder]="signingOrderEnabled" [data]="tableService.tableInputData" [columns]="tableColumns"
                [rowActions]="tableRowActions" actionColumnHeader="action" style="width:100%">
              </kzn-table>
            </div>
          </div>
        </div>
        }
      </div>
      } @else if (showImportedSignersPanel && tableService.tableInputData.length) {
      <div class="signer-panel" [class.signer-panel--active]="signerPanel === 'users'"
        [class.signer-panel--has-error]="manageUsersPanelHasErrors() && signerPanel !== 'users'">
        <button type="button" class="signer-panel__head" (click)="signerPanel = 'users'">
          <span class="signer-panel__radio" [class.is-on]="signerPanel === 'users'"></span>
          <span class="signer-panel__title">{{ 'manageUsers' | translate }}</span>
          @if (manageUsersPanelHasErrors() && signerPanel !== 'users') {
          <mat-icon class="signer-panel__error-icon" aria-hidden="true">error_outline</mat-icon>
          }
        </button>

        @if (signerPanel === 'users') {
        <div class="signer-panel__body signer-panel__body--users">
          <div class="signer-panel__users-box signer-panel__users-box--imported">
            <div class="signer-panel__users-table-wrap">
              <kzn-table [showSearch]="false" [showPagination]="false" [showOrderColumn]="true"
                [enableRowReorder]="false" [data]="tableService.tableInputData" [columns]="importedSignersTableColumns"
                [rowActions]="importedSignersRowActions" actionColumnHeader="action" style="width:100%">
              </kzn-table>
            </div>
          </div>
        </div>
        }
      </div>
      }


      <div class="signer-panel" [class.signer-panel--active]="signerPanel === 'other'"
        [class.signer-panel--has-error]="otherPanelHasErrors() && signerPanel !== 'other'">
        <button type="button" class="signer-panel__head" (click)="signerPanel = 'other'">
          <span class="signer-panel__radio" [class.is-on]="signerPanel === 'other'"></span>
          <span class="signer-panel__title">{{ 'otherInformation' | translate }}</span>
          @if (otherPanelHasErrors() && signerPanel !== 'other') {
          <mat-icon class="signer-panel__error-icon" aria-hidden="true">error_outline</mat-icon>
          }
        </button>

        @if (signerPanel === 'other') {
        <div class="signer-panel__body signer-panel__body--other" [formGroup]="requesterForm">
          <div class="signer-panel__other-box">
            @if (!isDraftRequest) {
            <div class="signer-panel__field-row">
              <label class="signer-panel__field-label">
                {{ 'chooseYourAppToken' | translate }}<span class="required-asterisk">*</span>
              </label>
              <mat-form-field appearance="outline"
                class="signer-panel__field signer-panel__field--full signer-panel__field--white"
                [class.field-invalid]="appToken.invalid && appToken.touched">
                <mat-select [formControl]="appToken" [placeholder]="'selectYourAppToken' | translate">
                  @for(token of allTokens; track token.AppName) {
                  <mat-option [value]="token">{{ token.AppName + ' (' + token.Token + ')' }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (appToken.invalid && appToken.touched) {
              <span class="field-error signer-panel__field-error">
                <mat-icon class="field-error__icon">error_outline</mat-icon> {{ 'requiredField' | translate }}
              </span>
              }
            </div>
            }

            <div class="signer-panel__field-row">
              <label class="signer-panel__field-label">{{ 'newRequestEmailSubject' | translate }}</label>
              <mat-form-field appearance="outline"
                class="signer-panel__field signer-panel__field--full signer-panel__field--white signer-panel__field--subject">
                <input matInput [placeholder]="'subject' | translate" formControlName="emailSubject" />
              </mat-form-field>
            </div>

            <div class="signer-panel__field-row">
              <label class="signer-panel__field-label">{{ 'requesterMessageToUser' | translate }}</label>
              <mat-form-field appearance="outline"
                class="signer-panel__field signer-panel__field--full signer-panel__field--white signer-panel__field--message">
                <textarea matInput rows="4" [placeholder]="'message' | translate" formControlName="message"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
        }
      </div>
    </div>

    <div class="wiz-actions wiz-actions--multi">
      <button mat-stroked-button type="button" class="wiz-btn-back" (click)="wizardSetupGoBack.emit()">{{ 'back' |
        translate }}</button>
      <button mat-stroked-button type="button" class="wiz-btn-reset" (click)="resetSignerStep()">{{ 'reset' | translate
        }}</button>
      <button mat-flat-button type="button" class="wiz-btn-orange" (click)="handleNextClick()">{{ 'continue' | translate
        }}</button>
    </div>
  </div>
  }

</div>